import React, { useEffect } from "react";
import Historial from "../components/Historial/Historial";
import i18n from "../i18n/config";

const HistorialPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("list.breadcrumb", { ns: "historial" })}`;
  }, []);

  return <Historial />;
};

export default HistorialPage;
